import React from 'react';
import { useMutation, useQueryClient } from 'react-query';
import externalApi from '../../api';

type NewTrackedEquipmentServiceRequest = {
  trackedEquipmentId: string;
  technicianUserId: string;
  serviceDateTime: Date;
  percentOxygen: number;
  flowRate: number;
  onHours: number;
  offHours: number;
  notes: string;
  readyForClean: boolean;
  lastUpdatedUserId: string;
};

type NewTrackedEquipmentServiceResponse = {
  trackedEquipmentServiceId: number;
};

function newTrackedEquipmentService(
  request: NewTrackedEquipmentServiceRequest
): Promise<NewTrackedEquipmentServiceResponse> {
  return externalApi.post(`TrackedEquipmentService/new`, { json: request }).json();
}

function useNewTrackedEquipmentService() {
  const queryClient = useQueryClient();
  return useMutation(
    (request: NewTrackedEquipmentServiceRequest) => newTrackedEquipmentService(request),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('TrackedEquipmentServiceByTrackedEquipment');
        queryClient.invalidateQueries('AllTrackedEquipment');
      },
    }
  );
}
export { useNewTrackedEquipmentService };
